import React, { useRef, useMemo, useEffect } from 'react';
import ClassNames from 'classnames';
var Tile = function Tile(props) {
  var tileRef = useRef();
  var children = props.children,
    classes = props.classes,
    date = props.date,
    formatAbbr = props.formatAbbr,
    locale = props.locale,
    maxDate = props.maxDate,
    minDate = props.minDate,
    onClick = props.onClick,
    onMouseOver = props.onMouseOver,
    style = props.style,
    view = props.view,
    tabIndex = props.tabIndex,
    dateValidator = props.dateValidator,
    disabledDates = props.disabledDates,
    disabledDays = props.disabledDays,
    disabledRanges = props.disabledRanges,
    mergedDisabledDatesIntervals = props.mergedDisabledDatesIntervals;
  var isDayExcluded = dateValidator.isDayExcluded,
    isDayInRange = dateValidator.isDayInRange,
    isMonthExcluded = dateValidator.isMonthExcluded,
    isMonthInRange = dateValidator.isMonthInRange,
    isYearInRange = dateValidator.isYearInRange,
    isYearExcluded = dateValidator.isYearExcluded;
  useEffect(function () {
    if (tabIndex === 0) {
      setTimeout(function () {
        tileRef.current && tileRef.current.focus();
      }, 0);
    }
  }, [tabIndex]);
  var isNeighboring = classes.indexOf('ap-single-day--neighboringMonth') !== -1;
  var disabled = useMemo(function () {
    var _disabled = false;
    if (view === "month") {
      _disabled = !isDayInRange(date, minDate, maxDate) || isDayExcluded(date, {
        disabledDates: disabledDates,
        disabledDays: disabledDays,
        disabledRanges: disabledRanges
      });
    }
    if (view === "year") {
      _disabled = !isMonthInRange(date, minDate, maxDate) || isMonthExcluded(date, mergedDisabledDatesIntervals);
    }
    if (view === 'decade') {
      _disabled = !isYearInRange(date, minDate, maxDate) || isYearExcluded(date, mergedDisabledDatesIntervals);
    }
    return _disabled || isNeighboring;
  }, [date, minDate, maxDate, disabledDates, disabledDays, disabledRanges, mergedDisabledDatesIntervals]);
  //disable only for month-day

  var content = formatAbbr ? /*#__PURE__*/React.createElement("abbr", {
    "aria-label": formatAbbr(locale, date)
  }, " ", children, " ") : children;
  return /*#__PURE__*/React.createElement("button", {
    className: ClassNames(classes, {
      'ap-single-day--excluded': disabled
    }),
    "aria-disabled": disabled,
    role: "button",
    onClick: onClick && function (e) {
      if (!disabled) {
        onClick(date, e, false);
      }
    },
    onMouseOver: onMouseOver && function () {
      return onMouseOver(date);
    },
    onFocus: onMouseOver && function () {
      return onMouseOver(date);
    },
    style: style,
    "aria-hidden": isNeighboring,
    type: "button",
    tabIndex: tabIndex,
    "aria-label": formatAbbr && formatAbbr(locale, date),
    ref: tileRef
  }, content);
};
export default Tile;